import React from 'react'
import { useContent } from '../contexts/ContentContext'

const WhatsAppButton: React.FC = () => {
  const { content } = useContent()

  // Get WhatsApp number from content or use fallback
  const whatsappNumber = content.contact?.whatsapp || '573507835575'

  // Format message: "Hola Jenny Kids, quiero información sobre sus colecciones"
  const message = encodeURIComponent('Hola Jenny Kids, quiero información sobre sus colecciones')
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      title="Escríbenos por WhatsApp"
    >
      {/* Button */}
      <button className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-200 animate-bounce">
        {/* WhatsApp Icon - Official Logo (High Definition) */}
        <svg
          className="w-6 h-6"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 2C6.48 2 2 6.48 2 12c0 1.54.36 3 .97 4.29L2 22l6.29-.97c1.29.61 2.75.97 4.29.97 5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.41 0-2.73-.36-3.88-.97l-.28-.15-2.89.44.44-2.89-.15-.28C4.36 14.73 4 13.41 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm3.71-8.04c-.2-.1-1.18-.58-1.37-.65-.19-.07-.33-.1-.47.1-.13.2-.52.65-.63.78-.12.13-.23.15-.43.05-.2-.1-.84-.31-1.6-.99-.59-.53-.99-1.19-1.1-1.39-.12-.2-.01-.31.09-.41.09-.09.2-.23.3-.35.1-.12.13-.2.2-.33.07-.13.04-.25-.02-.35-.07-.1-.47-1.13-.64-1.55-.17-.41-.33-.36-.47-.37-.12 0-.25-.01-.39-.01-.13 0-.33.05-.5.25-.18.2-.66.64-.66 1.56 0 .92.68 1.81.77 1.94.09.13 1.27 1.93 3.06 2.71.43.19.76.3.99.38.43.13.82.11 1.13.07.35-.05 1.06-.43 1.21-.85.15-.42.15-.78.1-.85-.04-.07-.15-.11-.31-.2z" />
        </svg>
      </button>

      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 bg-gray-900 text-white text-sm py-1 px-3 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        Escríbenos
      </div>
    </a>
  )
}

export default WhatsAppButton
